var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tool-bar" }, [
    _vm.viewIndex < _vm.viewlist.length - 1
      ? _c(
          "div",
          {
            staticClass: "bar-item",
            on: {
              click: function ($event) {
                return _vm.toDown(_vm.viewIndex)
              },
            },
          },
          [
            _c("img", {
              staticClass: "bar-img",
              attrs: { src: require("../assets/icon_xia@2x.png"), alt: "" },
            }),
            _c("span", [_vm._v("下移")]),
          ]
        )
      : _vm._e(),
    _vm.viewIndex > 0
      ? _c(
          "div",
          {
            staticClass: "bar-item",
            on: {
              click: function ($event) {
                return _vm.toUp(_vm.viewIndex)
              },
            },
          },
          [
            _c("img", {
              staticClass: "bar-img",
              attrs: { src: require("../assets/icon_shang@2x.png"), alt: "" },
            }),
            _c("span", [_vm._v("上移")]),
          ]
        )
      : _vm._e(),
    _c(
      "div",
      {
        staticClass: "bar-item",
        on: {
          click: function ($event) {
            return _vm.toEdit(_vm.viewIndex)
          },
        },
      },
      [
        _c("img", {
          staticClass: "bar-img",
          attrs: { src: require("../assets/icon_bianji@2x.png"), alt: "" },
        }),
        _c("span", [_vm._v("编辑")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "bar-item",
        on: {
          click: function ($event) {
            return _vm.toDel(_vm.viewIndex)
          },
        },
      },
      [
        _c("img", {
          staticClass: "bar-img",
          attrs: { src: require("../assets/icon_shanchu@2x.png"), alt: "" },
        }),
        _c("span", [_vm._v("删除")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }